import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
	IdsActionButtonModule,
	IdsFormFieldModule,
	IdsIconButtonModule,
	IdsIconModule,
	IdsInputModule,
	IdsLoadingComponent,
	IdsLoadingModule,
	IdsMainButtonModule,
	IdsModalModule,
	IdsShimmerModule,
	IdsSnackbarModule,
	IdsSuffixDirective,
} from '@ids/angular';
import { AlertContainerComponent } from './components/alert-container/alert-container.component';
import { InputFieldComponent } from './components/input-field/input-field.component';
import { LabelComponent } from './components/label/label.component';
import { DynamicTemplateComponent } from './components/modal/dynamic-template/dynamic-template.component';
import { ModalComponent } from './components/modal/modal.component';
// import { SharedModule } from '../shared.module';
import { ModalService } from './components/modal/modal.service';
import { ModalFooterComponent } from './components/modal/modal-footer/modal-footer.component';
import { ShimmerComponent } from './components/shimmer/shimmer.component';
import { AlertService } from './services/alert/alert.service';

@NgModule({
	declarations: [
		AlertContainerComponent,
		ShimmerComponent,
		InputFieldComponent,
		ModalComponent,
		ModalFooterComponent,
		DynamicTemplateComponent,
		LabelComponent,
	],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		IdsSnackbarModule,
		IdsIconModule,
		IdsShimmerModule,
		IdsModalModule,
		IdsFormFieldModule,
		IdsIconModule,
		IdsIconButtonModule,
		IdsInputModule,
		IdsSuffixDirective,
		IdsMainButtonModule,
		IdsActionButtonModule,
		IdsLoadingComponent,
		IdsLoadingModule,
	],
	providers: [],
	exports: [
		AlertContainerComponent,
		ShimmerComponent,
		InputFieldComponent,
		ModalComponent,
		ModalFooterComponent,
		DynamicTemplateComponent,
		LabelComponent,
	],
})
export class ToolkitModule {}
